import { Header, HeaderLogoWithName } from '.'
import { Back, Cart, NavMenu, OrderNow, ClaimRewardCodeButton } from './buttons'

const HeaderDefault = ({
  maxWidth = '100%',
  path,
  showOrderNow = true,
  showLogo = true,
  showClaimRewardCodeButton = false,
}: {
  maxWidth?: string
  path?: string
  showOrderNow?: boolean
  showLogo?: boolean
  showClaimRewardCodeButton?: boolean
}) => {
  return (
    <Header
      maxWidth={maxWidth}
      left={<Back path={path} />}
      title={
        showLogo ? (
          <HeaderLogoWithName />
        ) : (
          showClaimRewardCodeButton && <ClaimRewardCodeButton />
        )
      }
      right={
        <>
          {showLogo && showClaimRewardCodeButton && <ClaimRewardCodeButton />}
          <Cart />
          {showOrderNow && <OrderNow />}
          <NavMenu />
        </>
      }
    />
  )
}

export default HeaderDefault
